import React from "react";

export const TelegramIcon = ({ width = "32", height = "32", color="#2AABEE", opacity='1' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_263_140)">
        <path
          d="M16.6773 0C12.4468 0.0197426 8.39627 1.71416 5.41182 4.71261C2.42736 7.71105 0.751907 11.7694 0.751953 16C0.751953 20.2435 2.43766 24.3131 5.43824 27.3137C8.43883 30.3143 12.5085 32 16.752 32C20.9954 32 25.0651 30.3143 28.0657 27.3137C31.0662 24.3131 32.752 20.2435 32.752 16C32.752 11.7565 31.0662 7.68687 28.0657 4.68629C25.0651 1.68571 20.9954 0 16.752 0L16.6773 0ZM23.2933 9.632C23.4266 9.62933 23.7213 9.66267 23.9133 9.81867C24.0415 9.92896 24.123 10.0839 24.1413 10.252C24.1626 10.376 24.1893 10.66 24.168 10.8813C23.928 13.412 22.8853 19.5507 22.3546 22.384C22.1306 23.584 21.6893 23.9853 21.2613 24.024C20.3333 24.1107 19.628 23.4107 18.728 22.8213C17.32 21.8973 16.524 21.3227 15.1573 20.4213C13.5773 19.3813 14.6013 18.808 15.5013 17.8747C15.7373 17.6293 19.8306 13.9053 19.9106 13.568C19.92 13.5253 19.9293 13.368 19.836 13.2853C19.7426 13.2027 19.604 13.2307 19.504 13.2533C19.3626 13.2862 17.1133 14.7729 12.756 17.7133C12.116 18.1533 11.5373 18.3667 11.02 18.3533C10.4493 18.3427 9.35062 18.032 8.53329 17.7667C7.53062 17.44 6.73462 17.268 6.80395 16.7147C6.83951 16.4267 7.2364 16.132 7.99462 15.8307C12.6586 13.7987 15.7688 12.4591 17.3253 11.812C21.768 9.964 22.692 9.64267 23.2933 9.632Z"
          fill={color}
          fillOpacity={opacity}
        />
      </g>
      <defs>
        <clipPath id="clip0_263_140">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0.751953)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
